/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Tile_CsvInputs */

const cs_import_tile_csv = /** @type {(inputs: Import_Tile_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obecné CSV`)
};

const en_import_tile_csv = /** @type {(inputs: Import_Tile_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generic CSV`)
};

/**
* | output |
* | --- |
* | "Generic CSV" |
*
* @param {Import_Tile_CsvInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_tile_csv = /** @type {((inputs?: Import_Tile_CsvInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Tile_CsvInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_tile_csv(inputs)
	return cs_import_tile_csv(inputs)
});